import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtag from "vue-gtag-next";

createApp(App).use(store).use(router).use(VueAxios,axios).use(VueGtag,{ property: { id: "G-RLVFB6Y2T1" }}).mount('#app')
